import { NgModule } from '@angular/core';
import { TranslatePipe } from 'src/translate/translate.pipe';

@NgModule({
  declarations: [TranslatePipe],
  exports: [TranslatePipe]
})
export class TranslateModule { }
